import * as FullStory from "@fullstory/browser";
import { Seller, User } from "types";
import { config } from "../config";
import { isXolaAdmin } from "../models/User";
import { getReleaseInfo } from "./helpers";
import { registerSnippet } from "./index";

registerSnippet("FullStory", !!config.fullstory.id, (user: User, seller: Seller) => {
    FullStory.init({
        orgId: config.fullstory.id,
        debug: false,
        // Set to true if you want to deactivate FullStory in your development environment. Default false
        // devMode: false,
    });

    const userName = user.name ?? user.id;
    const displayName = isXolaAdmin(user) ? `${userName} as ${seller.name}` : userName;
    const displayEmail = isXolaAdmin(user) ? `${user.email}::${seller.email}` : user.email;
    const { env: environment } = getReleaseInfo();
    const userOptions = {
        app_str: "x2-seller",
        env_str: environment,
        displayName,
        email_str: displayEmail,
        roles: user.roles,
        sellerName_str: seller.name ?? "Unknown Seller",
        sellerEmail_str: seller.email ?? "Unknown Seller",
    };
    FullStory.identify(user.id, userOptions);
});
